<!--
  -  Copyright (c) Qwoach LLC 2020. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 25/12/2020
  -->

<template>
	<button class="link-button" v-bind="listenersComputed" type="button">
		<slot></slot>
	</button>
</template>

<script>

import QwBaseButton from "@/core/components/Controls/Buttons/QwBaseButton.vue";

export default {
	name: "QwLinkButton",
	extends: QwBaseButton,
	// inheritAttrs: false,
}
</script>

<style lang="scss">


</style>
